import { SET_INCOMING_URL } from './types';

export const setIncomingUrl = (url) => ({
        type: SET_INCOMING_URL,
        payload: {url}
  })
  